<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.25436 44.7065C8.17079 44.7065 7.23976 44.3173 6.46126 43.5387C5.68272 42.7602 5.29346 41.8292 5.29346 40.7456V10.2543C5.29346 9.16301 5.68272 8.22531 6.46126 7.44125C7.23976 6.65721 8.17079 6.2652 9.25436 6.2652H12.25V3.2652H15.9805V6.2652H32.0196V3.2652H35.75V6.2652H38.7457C39.837 6.2652 40.7747 6.65721 41.5588 7.44125C42.3428 8.22531 42.7348 9.16301 42.7348 10.2543V40.7456C42.7348 41.8292 42.3428 42.7602 41.5588 43.5387C40.7747 44.3173 39.837 44.7065 38.7457 44.7065H9.25436ZM9.25436 40.7456H38.7457V19.5H9.25436V40.7456ZM9.25436 16.5H38.7457V10.2543H9.25436V16.5ZM14 27.1978V23.8587H34V27.1978H14ZM14 36.113V32.8021H27.95V36.113H14Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
